// Mint Stats Contract ABI
import {Address} from 'viem'

export const MINT_STATS_ABI = [{"inputs": [], "stateMutability": "nonpayable", "type": "constructor"}, {
  "inputs": [{"internalType": "address", "name": "sender", "type": "address"}, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {
    "internalType": "address",
    "name": "owner",
    "type": "address"
  }], "name": "ERC721IncorrectOwner", "type": "error"
}, {"inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "ERC721InsufficientApproval", "type": "error"}, {
  "inputs": [{"internalType": "address", "name": "approver", "type": "address"}],
  "name": "ERC721InvalidApprover",
  "type": "error"
}, {"inputs": [{"internalType": "address", "name": "operator", "type": "address"}], "name": "ERC721InvalidOperator", "type": "error"}, {"inputs": [{"internalType": "address", "name": "owner", "type": "address"}], "name": "ERC721InvalidOwner", "type": "error"}, {
  "inputs": [{
    "internalType": "address",
    "name": "receiver",
    "type": "address"
  }], "name": "ERC721InvalidReceiver", "type": "error"
}, {"inputs": [{"internalType": "address", "name": "sender", "type": "address"}], "name": "ERC721InvalidSender", "type": "error"}, {"inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "ERC721NonexistentToken", "type": "error"}, {
  "anonymous": false,
  "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {"indexed": true, "internalType": "address", "name": "approved", "type": "address"}, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
  "name": "Approval",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{"indexed": true, "internalType": "address", "name": "owner", "type": "address"}, {"indexed": true, "internalType": "address", "name": "operator", "type": "address"}, {"indexed": false, "internalType": "bool", "name": "approved", "type": "bool"}],
  "name": "ApprovalForAll",
  "type": "event"
}, {"anonymous": false, "inputs": [{"indexed": false, "internalType": "uint256", "name": "_fromTokenId", "type": "uint256"}, {"indexed": false, "internalType": "uint256", "name": "_toTokenId", "type": "uint256"}], "name": "BatchMetadataUpdate", "type": "event"}, {
  "anonymous": false,
  "inputs": [{"indexed": false, "internalType": "uint256", "name": "_tokenId", "type": "uint256"}],
  "name": "MetadataUpdate",
  "type": "event"
}, {
  "anonymous": false,
  "inputs": [{"indexed": true, "internalType": "address", "name": "from", "type": "address"}, {"indexed": true, "internalType": "address", "name": "to", "type": "address"}, {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"}],
  "name": "Transfer",
  "type": "event"
}, {"inputs": [], "name": "BASE_PRICE", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "PRICE_INCREMENT",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "PRICE_STEP", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [{"internalType": "uint256", "name": "newStock", "type": "uint256"}],
  "name": "addStockNFT",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {"inputs": [{"internalType": "address", "name": "to", "type": "address"}, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "approve", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
  "inputs": [{
    "internalType": "address",
    "name": "owner",
    "type": "address"
  }], "name": "balanceOf", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"
}, {"inputs": [{"internalType": "uint256", "name": "amountToBuyWith", "type": "uint256"}], "name": "buyLRSN", "outputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}], "stateMutability": "payable", "type": "function"}, {
  "inputs": [],
  "name": "contractOwner",
  "outputs": [{"internalType": "address", "name": "", "type": "address"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "getApproved", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "getMintPrice",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "getNftStock", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "implementation",
  "outputs": [{"internalType": "address", "name": "", "type": "address"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "initContract", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
  "inputs": [{"internalType": "address", "name": "owner", "type": "address"}, {"internalType": "address", "name": "operator", "type": "address"}],
  "name": "isApprovedForAll",
  "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "larissaMainDao", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "mintNFT",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "payable",
  "type": "function"
}, {"inputs": [], "name": "mintNftByLRSN", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "nonpayable", "type": "function"}, {
  "inputs": [],
  "name": "name",
  "outputs": [{"internalType": "string", "name": "", "type": "string"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "name": "nftLevel", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "name": "nftMintTime",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "ownerOf", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [{
    "internalType": "address",
    "name": "from",
    "type": "address"
  }, {"internalType": "address", "name": "to", "type": "address"}, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "safeTransferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function"
}, {
  "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {"internalType": "address", "name": "to", "type": "address"}, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}, {"internalType": "bytes", "name": "data", "type": "bytes"}],
  "name": "safeTransferFrom",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}, {"inputs": [{"internalType": "uint256", "name": "lrsnValue", "type": "uint256"}], "name": "sendLrsnToMainDao", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
  "inputs": [{"internalType": "address", "name": "operator", "type": "address"}, {
    "internalType": "bool",
    "name": "approved",
    "type": "bool"
  }], "name": "setApprovalForAll", "outputs": [], "stateMutability": "nonpayable", "type": "function"
}, {"inputs": [{"internalType": "address", "name": "newAddress", "type": "address"}], "name": "setMainDao", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
  "inputs": [{"internalType": "bytes4", "name": "interfaceId", "type": "bytes4"}],
  "name": "supportsInterface",
  "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "symbol", "outputs": [{"internalType": "string", "name": "", "type": "string"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
  "name": "tokenURI",
  "outputs": [{"internalType": "string", "name": "", "type": "string"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "totalL1Minted", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "totalL2Minted",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "totalL3Minted", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [],
  "name": "totalMinted",
  "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
  "stateMutability": "view",
  "type": "function"
}, {"inputs": [], "name": "totalSupply", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
  "inputs": [{"internalType": "address", "name": "from", "type": "address"}, {
    "internalType": "address",
    "name": "to",
    "type": "address"
  }, {"internalType": "uint256", "name": "tokenId", "type": "uint256"}], "name": "transferFrom", "outputs": [], "stateMutability": "nonpayable", "type": "function"
}] as const;

export const MINT_STATS_CONTRACT = (import.meta.env.VITE_MINT_STATS_CONTRACT_ADDRESS || '') as `0x${string}`;

